// Pricer grid field names: row fields, Greeks and units. Data only: no JSX,
// no component imports (A2-1600).

export const FIELD_NAMES = {
  ROW_TYPE: "row_type",
  FIRST_GREEK: "first_greek",
  SECOND_GREEK: "second_greek",
  OPTION_ROW_ID: "option_row_id",
  SUMMARY_ID: "summary_id",
  LEG_ID: "leg_id",
  LIVE: "live",
  IS_AUTO_UPDATE_VOL: "is_auto_update_vol",
  PRODUCT: "product",
  CONTRACT: "contract",
  STYLE: "style",
  RISK_FREE: "risk_free",
  TENOR_LEG: "tenor.leg",
  TENOR: "tenor",
  UNDERLYING: "underlying",
  STRIKE: "strike",
  TYPE: "type",
  RATIO: "ratio",
  BID_QTY: "bid_quantity",
  BID_PERCENTAGE: "bid_percentage",
  BID: "bid",
  IS_LOCKED: "is_locked",
  IS_ACTIVE: "is_active",
  ASK: "ask",
  COMPANY: "company_value",
  ASK_PERCENTAGE: "ask_percentage",
  ASK_QTY: "ask_quantity",
  ACTIONS: "actions",
  SUMMARY_REFERENCE_ID: "summary_reference_id",
  LEG_REFERENCE_ID: "leg_reference_id",
  COPY_SHORTHAND: "copy_shorthand",
  COPY_SHORTHAND_WITH_DELTA: "copy_shorthand_with_delta",
  COPY_SHORTHAND_NO_VOLS: "copy_shorthand_without_vol",
  COPY_SHORTHAND_NO_VOL_PREM: "copy_shorthand_without_vol_prem",
  COPY_SHORTHAND_LEGS: "copy_shorthand_legs",
  ID: "id",
  VOLATILITY_UNIT: "volatility_unit",
  QUANTITY_UNIT: "premium_quantity_unit",
  PREMIUM_UNIT: "premium_unit",
  LEVEL_ONE_ROW_TYPE: "level_one_row_type",
  LEVEL_ZERO_ROW_TYPE: "level_zero_row_type",
  SUB_LEG: "subleg",
  LEG: "leg",
  SUMMARY: "summary",
  LEG_SUMMARY: "leg-summary",
  BID_DELTA: "bid_delta",
  COMPANY_VALUE: "company_value",
  COMPANY_PERCENTAGE: "company_percentage",
  ASK_DELTA: "ask_delta",
  CALCULATION_DATE: "calculation_date",
  SUMMARY_AGG: "summary_agg",
  LEG_AGG: "leg_agg",
  LEVEL: "level",
  LEGS: "legs",
  FIELD: "field",
};

export const GREEKS_COLUMNS_FIELDS_NAME = {
  //? BID
  BID_DELTA: "bid_delta",
  BID_THETA: "bid_theta",
  BID_GAMMA: "bid_gamma",
  BID_VEGA: "bid_vega",
  BID_RHO: "bid_rho",
  BID_TOTAL_PREMIUM: "bid_total_premium",
  BID_TOTAL_QTY: "bid_total_quantity",
  BID_GAMMA_QTY: "bid_gamma_quantity",
  BID_DELTA_QTY: "bid_delta_quantity",
  BID_THETA_CURRENCY: "bid_theta_currency",
  BID_VEGA_CURRENCY: "bid_vega_currency",
  BID_RHO_CURRENCY: "bid_rho_currency",
  BID_BREAKEVEN: "bid_breakeven",
  //? ASK
  ASK_DELTA: "ask_delta",
  ASK_THETA: "ask_theta",
  ASK_GAMMA: "ask_gamma",
  ASK_VEGA: "ask_vega",
  ASK_RHO: "ask_rho",
  ASK_TOTAL_PREMIUM: "ask_total_premium",
  ASK_TOTAL_QTY: "ask_total_quantity",
  ASK_GAMMA_QTY: "ask_gamma_quantity",
  ASK_DELTA_QTY: "ask_delta_quantity",
  ASK_THETA_CURRENCY: "ask_theta_currency",
  ASK_VEGA_CURRENCY: "ask_vega_currency",
  ASK_RHO_CURRENCY: "ask_rho_currency",
  ASK_BREAKEVEN: "ask_breakeven",
};

export const UNIT_COLUMNS_FIELDS_NAME = {
  //? BID
  PREMIUM_UNIT: "premium_unit",
  UNDERLYING_UNIT: "underlying_unit",
  STRIKE_UNIT: "strike_unit",
  RISK_FREE_UNIT: "risk_free_unit",
  VOLATILITY_UNIT: "premium_percentage_unit",
  THETA_UNIT: "premium_theta_unit",
  DELTA_UNIT: "premium_delta_unit",
  GAMMA_UNIT: "premium_gamma_unit",

  PREMIUM_QUANTITY_UNIT: "premium_quantity_unit",
  PREMIUM_VEGA_CURRENCY_UNIT: "premium_vega_currency_unit",
  PREMIUM_RHO_CURRENCY_UNIT: "premium_rho_currency_unit",
  PREMIUM_TOTAL_PREMIUM_UNIT: "premium_total_premium_unit",

  PREMIUM_BREAKEVEN_UNIT: "premium_breakeven_unit",
  PREMIUM_VEGA_UNIT: "premium_vega_unit",
  PREMIUM_RHO_UNIT: "premium_rho_unit",
  PREMIUM_THETA_CURRENCY_UNIT: "premium_theta_currency_unit",

  PREMIUM_GAMMA_QUANTITY_UNIT: "premium_gamma_quantity_unit",
  PREMIUM_DELTA_QUANTITY_UNIT: "premium_delta_quantity_unit",
  PREMIUM_TOTAL_QUANTITY_UNIT: "premium_total_quantity_unit",
};

export const GREEK_COLUMNS_WITH_LABELS = {
  company: [
    {
      key: "company_value",
      label: "Est Prem",
    },
    {
      key: "company_percentage",
      label: "Est %",
    },
  ],
  bid: [
    {
      key: "bid_delta",
      label: "Bid Delta",
    },
    {
      key: "bid_delta_quantity",
      label: "Bid Delta Quantity",
    },
    {
      key: "bid_gamma",
      label: "Bid Gamma",
    },
    {
      key: "bid_gamma_quantity",
      label: "Bid Gamma Quantity",
    },
    {
      key: "bid_theta",
      label: "Bid Theta",
    },
    {
      key: "bid_theta_currency",
      label: "Bid Theta Currency",
    },
    {
      key: "bid_rho",
      label: "Bid Rho",
    },
    {
      key: "bid_rho_currency",
      label: "Bid Rho Currency",
    },
    {
      key: "bid_vega",
      label: "Bid Vega",
    },
    {
      key: "bid_vega_currency",
      label: "Bid Vega Currency",
    },
    {
      key: "bid_skew_delta",
      label: "Bid Skew Delta",
    },
    {
      key: "bid_breakeven",
      label: "Bid Breakeven",
    },
    {
      key: "bid_total_premium",
      label: "Bid Total Premium",
    },
    {
      key: "bid_total_quantity",
      label: "Bid Total Quantity",
    },
  ],
  ask: [
    {
      key: "ask_delta",
      label: "Ask Delta",
    },
    {
      key: "ask_delta_quantity",
      label: "Ask Delta Quantity",
    },
    {
      key: "ask_gamma",
      label: "Ask Gamma",
    },
    {
      key: "ask_gamma_quantity",
      label: "Ask Gamma Quantity",
    },
    {
      key: "ask_theta",
      label: "Ask Theta",
    },
    {
      key: "ask_theta_currency",
      label: "Ask Theta Currency",
    },
    {
      key: "ask_rho",
      label: "Ask Rho",
    },
    {
      key: "ask_rho_currency",
      label: "Ask Rho Currency",
    },
    {
      key: "ask_vega",
      label: "Ask Vega",
    },
    {
      key: "ask_vega_currency",
      label: "Ask Vega Currency",
    },
    {
      key: "ask_skew_delta",
      label: "Ask Skew Delta",
    },
    {
      key: "ask_total_premium",
      label: "Ask Total Premium",
    },
    {
      key: "ask_total_quantity",
      label: "Ask Total Quantity",
    },
  ],
};

export const PRICER_TRADER_GREEK_SLOT_COUNT = 6;

function isBidGreekQuantityOrCurrencyField(key) {
  return key.includes("_quantity") || key.includes("_currency");
}

/** Bid greek keys in list order, skipping quantity/currency rows (first N slots). */
export function getDefaultTraderGreekFields() {
  const fromList = GREEK_COLUMNS_WITH_LABELS.bid
    .map(({ key }) => key)
    .filter((key) => !isBidGreekQuantityOrCurrencyField(key))
    .slice(0, PRICER_TRADER_GREEK_SLOT_COUNT);
  const pad = "bid_delta";
  while (fromList.length < PRICER_TRADER_GREEK_SLOT_COUNT) {
    fromList.push(pad);
  }
  return fromList;
}
